<template>
<div>
  <div class="my-account">
    <div class="wrapper">
      <div style="border-style:solid; border-width:1px; border-color:#a35608;padding:0.36rem 0 0.05rem 0;width:95%;margin:0 auto;border-radius:0.2rem">
            <div style="font-size:0.35rem;color:#a35608;margin-left:0.3rem">当前管理员可操作以下功能：</div>
            <div style="font-size:0.35rem;color:#a35608;margin-left:0.3rem">当前待授权寺院：{{this.$route.query.cateName}}</div>
            <div class="nav acea-row row-middle" style="margin-left:0.3rem">
                
                <input
                    type="text"
                    placeholder="请填写微信昵称"
                    style="padding-left:0.3rem;color:#a35608;height:0.75rem;border-radius:0.1rem;border-color:#a35608;border-style:solid; border-width:1px;"
                    v-model="nickname"
                />
                &nbsp;
                <button type="button" @click="queryUserInfoList" style="border-style:solid; border-width:1px; border-color:#a35608;border-radius:0.16rem;height:0.75rem;width:2.2rem">
                    查询微信用户
                </button>
                <!-- <button type="button" @click="queryUserInfoList" style="border-style:solid; border-width:1px; border-color:#a35608;border-radius:0.16rem;height:0.75rem;width:2.2rem">
                    查询所有管理员
                </button> -->
            </div>
      </div> 
    </div>

    <div class="wrapper" style="padding-left:0.3rem;color:#a35608;" v-for="(item, index) in userInfoList" :key="index">
        <!-- <router-link :to="{path:'/user/merchantDevice',query:{cateId:item.id} }" style="color:#999;">
            <div >
                <img :src="item.avatar" style="width:1rem;border-radius:1rem;"/><span>{{item.nickname}}</span>
            </div>
        </router-link> -->
        <table style="width:95%" >
            <tr>
                <td style="width:1.25rem">
                    <img :src="item.avatar" style="width:1rem;border-radius:1rem;"/>
                </td>
                <td >
                    {{item.nickname}}<span v-if="item.adminid>0" style="color:red">（寺庙管理员:{{item.adminid}}）</span>
                </td>
                <td align="right">
                    <button type="button" @click="confirmUserGrant(item)" style="border-style:solid; border-width:1px; border-color:#a35608;border-radius:0.16rem;height:0.75rem;width:2.2rem">
                    授权管理
                    </button>
                </td>
            </tr>
        </table>




        <!-- 授权管理人 -->
    </div>

  </div>
</div>
</template>
<script>
// import Recommend from "@components/Recommend";
// import { getBalance } from "../../api/user";
// import { queryDevice,device,deviceTiming } from "../../api/lamp";
// import lazhu from '@assets/images/lazhu1.png'
// import lazhusingle from '@assets/images/lazhusingle.png'

// import initData from '@/mixins/crud'
// import VueTimepicker from 'vue2-timepicker'
// CSS
// import 'vue2-timepicker/dist/VueTimepicker.css'

// import Datepicker from 'vuejs-datepicker';
// import {zh} from 'vuejs-datepicker/dist/locale'


// import { Picker } from 'vant'
import {getUserInfoList,getUserGrant} from "@api/user";
import { getCategoryAll,addCategory } from "@api/store";
import { mapGetters } from "vuex";

export default {
  name: "SystemSet",
  components: {
  },
  props: {},
  data: function() {
//  const customFieldName = {
//       text: 'cateName',
//       values: 'id',
//     };
    return {
        nickname:"",
        userInfoList:[],

        categoryList:[],
        showWin:0,
        cateName: ""
    };
  },
  computed: mapGetters(["userInfo","isLogin"]),
  mounted: function() {
    this.cateName=this.$route.query.cateName
    this.getCategoryAll();
    this.queryUserInfoList();
  },
  methods: {
    checkIsLogin(){
      const isLogin = this.isLogin;
      if (!isLogin) return toLogin();
    },
    getUserInfo(){
          this.$store.dispatch("USERINFO").then((res) => {
                this.adminid=res.adminid
          });
    },
    getCategoryAll(){
        getCategoryAll().then(
          res => {
            this.categoryList = res.data;
          },
          err => {
            this.$dialog.message(err.msg);
          }
        );
    },
    addCategoryConfirm(){
        addCategory({
            cateName:this.cateName
        }).then(
          res => {
            this.$dialog.message("添加成功");
            this.showWin = 0;
            this.getCategoryAll()
          },
          err => {
            this.$dialog.message(err.msg);
          }
        );
    },
    confirmUserGrant(item){
        this.$dialog.confirm({
          mes: "您确认授权给当前寺院:"+this.$route.query.cateName,
          opts: () => {
            this.userGrant(item);
          }
        });
    },
    userGrant(item){
        getUserGrant({
            cateId:this.$route.query.cateId,
            uid:item.uid
        }).then(
          res => {
            this.$dialog.message("授权成功");
          },
          err => {
            this.$dialog.message(err.msg);
          }
        );
    },
    queryUserInfoList(){
        let data = {
            nickname: this.nickname
        };
        getUserInfoList(data).then(
          res => {
            this.$dialog.message("查询成功");
            this.userInfoList= res.data
          },
          err => {
            this.$dialog.message(err.msg);
          }
        );
    }
  }
};
</script>
<style scoped>
.checked{
  background: #f78817;
 }

.center {
  width:95%; 
  height:3rem; 
  z-index:99; 
  top: 3rem;
  background-color:#a35608;
  position: fixed;
  left: 0;
  right: 0;
  margin:0 auto;
  border-radius:0.16rem;
}
.centerdiv {
  font-size:0.35rem;
  margin-top:0.4rem;
  margin-left:0.4rem;
  color:#f8e006;
}
.selectdiv {
  margin-left:0.2rem;
  background-color:red;
  border-radius:0.16rem;
}
.buttonStyle {
  float:left;
  text-align:center;
  line-height: 0.75rem;
  margin-right:0.5rem;
  border-style:solid;
  border-width:1px; 
  border-color:#f8e006;
  border-radius:0.16rem;
  height:0.75rem;
  width:1.2rem
}
.buttonDiv {
  font-size:0.35rem;
  margin-top:0.5rem;
  margin-left:0.4rem;
  color:#f8e006;
  float:right;
}


 </style>
